module.exports = __webpack_public_path__ + "img/EmailInbox.852ba18f.png";